import React, { useEffect } from 'react';
import nProgress from 'nprogress';
import 'nprogress/nprogress.css';
import favicon from "../../assets/logo/nendax-fav.png";

nProgress.configure({ showSpinner: false });

const ProgressLoader = ({ children, isLoading, noProgressBar = false, style }) => {

  useEffect(() => {
    if (isLoading && !noProgressBar) {
      nProgress.start();
      nProgress.set(0.2)
    } else {
      nProgress.done();
    }
  }, [isLoading, noProgressBar]);

  return (
    <>
      {isLoading && (
        <div className="nendax-preloader" aria-label="Loading">
          <img src={favicon} alt="" />
        </div>
      )}
      {children}
    </>
  );
};

export default ProgressLoader;
